import type { IHttpError } from '@wix/http-client';
import { HttpClient } from '@wix/http-client';

export type HttpErrorResponse =
  | {
      message?: string;
      error?: string;
      details?: {
        applicationError?: { code?: string };
        validationError?: {
          fieldViolations?: Array<{
            violatedRule: string;
            field: string;
            description: string;
          }>;
        };
      };
    }
  | undefined;

export function isHttpError(
  error: unknown
): error is IHttpError<HttpErrorResponse> {
  return HttpClient.isHttpError(error);
}
